import {
  COMPANY_TYPES,
  COMPANY_TYPE_LABEL,
  type CompanyType,
  type Errors,
  type KybDraft,
} from '~/lib/kyb';
import {
  Field,
  SectionCard,
  Select,
  TextArea,
  TextInput,
  TwoCol,
} from './Primitives';

export function BusinessStep({
  draft,
  errors,
  update,
}: {
  draft: KybDraft;
  errors: Errors;
  update: (patch: Partial<KybDraft>) => void;
}): JSX.Element {
  return (
    <SectionCard
      title="Business information"
      description="The business as it's registered with CAC. This is what appears on your contract with Seven."
    >
      <div className="flex flex-col gap-4">
        <Field label="Registered business name" error={errors.appliedCompanyName}>
          <TextInput
            value={draft.appliedCompanyName}
            onChange={(v) => update({ appliedCompanyName: v })}
            autoComplete="organization"
            placeholder="Acme Ltd"
            invalid={!!errors.appliedCompanyName}
          />
        </Field>

        <Field
          label="What does the business do?"
          hint="One or two sentences. Reviewers use this to decide which checks apply."
          error={errors.businessDescription}
        >
          <TextArea
            value={draft.businessDescription}
            onChange={(v) => update({ businessDescription: v })}
            maxLength={2000}
            invalid={!!errors.businessDescription}
            placeholder="A fleet payments platform for Lagos logistics companies — issues cards to drivers and settles fuel spend weekly."
          />
        </Field>

        <TwoCol>
          <Field label="Company type" error={errors.companyType}>
            <Select<CompanyType>
              value={draft.companyType}
              onChange={(v) => update({ companyType: v })}
              placeholder="Choose…"
              invalid={!!errors.companyType}
              options={COMPANY_TYPES.map((v) => ({
                value: v,
                label: COMPANY_TYPE_LABEL[v],
              }))}
            />
          </Field>
          <Field label="RC number" error={errors.rcNumber}>
            <TextInput
              value={draft.rcNumber}
              onChange={(v) => update({ rcNumber: v })}
              placeholder="RC-1234567"
              invalid={!!errors.rcNumber}
            />
          </Field>
        </TwoCol>

        <Field
          label="Tax identification number (TIN)"
          hint="The FIRS-issued TIN for this business."
          error={errors.tin}
        >
          <TextInput
            value={draft.tin}
            onChange={(v) => update({ tin: v })}
            placeholder="12345678-0001"
            invalid={!!errors.tin}
          />
        </Field>
      </div>
    </SectionCard>
  );
}
